import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10.8 10.833V12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor" /> <path d="M10.8 16.042a6.042 6.042 0 1 0 0-12.084 6.042 6.042 0 0 0 0 12.084Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);